import { ref, onUnmounted } from 'vue'
import { useToast } from '@/composables/common/useToast'
import store from '@/store'
import { config } from '@/config.js'

export function useDeportistaLesiones(props, base) {
    const toast = useToast()

    // ==================== STATE ====================
    const showAddLesionModal = ref(false)
    const showBorrarLesionModal = ref(false)

    const lesionesSearch = ref('')
    const lesionesFilter = ref('orientacion_diagnostica')

    // ==================== SEARCH ====================
    let lesionesDebounceTimer = null

    onUnmounted(() => {
        clearTimeout(lesionesDebounceTimer)
    })

    /**
     * Actualiza el texto de búsqueda de lesiones con debounce de 500ms
     */
    function updateLesionesSearch(value) {
        lesionesSearch.value = value
        clearTimeout(lesionesDebounceTimer)
        lesionesDebounceTimer = setTimeout(() => {
            getLesiones()
        }, 500)
    }

    /**
     * Actualiza el filtro de lesiones y recarga inmediatamente
     */
    function updateLesionesFilter(value) {
        lesionesFilter.value = value
        getLesiones()
    }

    /**
     * Carga las lesiones del deportista desde el endpoint dedicado
     */
    async function getLesiones() {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            filters: {
                page: 1,
                numPage: 999,
                search: lesionesSearch.value,
                selected: lesionesFilter.value
            }
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.lesiones'),
                params
            )
            if (base.value) {
                base.value = {
                    ...base.value,
                    lesiones: res.data.data || []
                }
            }
        } catch (error) {
            console.error('Error fetching lesiones:', error)
            toast.error('Error al cargar las lesiones')
        }
    }

    /**
     * Agregar una lesión al deportista
     */
    async function addLesion(data) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            ...data
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.lesiones.create'),
                params
            )
            toast.success(res.data.message || 'Lesión agregada correctamente')
            await getLesiones()
            showAddLesionModal.value = false
        } catch (error) {
            console.error('Error adding lesion:', error)
            toast.error(error.response?.data?.message || 'Error al agregar la lesión')
        }
    }

    /**
     * Borrar una lesión
     */
    async function deleteLesion(lesion_id) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            lesion_id: lesion_id
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.lesiones.delete'),
                params
            )
            toast.success(res.data.message || 'Lesión eliminada correctamente')
            await getLesiones()
            showBorrarLesionModal.value = false
        } catch (error) {
            console.error('Error deleting lesion:', error)
            toast.error(error.response?.data?.message || 'Error al eliminar la lesión')
        }
    }

    return {
        showAddLesionModal,
        showBorrarLesionModal,
        lesionesSearch,
        lesionesFilter,
        updateLesionesSearch,
        updateLesionesFilter,
        getLesiones,
        addLesion,
        deleteLesion,
    }
}
